<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div *ngFor="let item of reachUs" class="col-md-4 col-xl-4 box-col-4">
        <div class="card custom-card"  style="min-height:405px">
            <div class="card-header"><img class="img-fluid" src="https://angular.pixelstrap.com/cuba/assets/images/user-card/3.jpg" alt=""></div>
            <div class="card-profile"><img class="rounded-circle" [src]="item.picture" alt=""></div>
            <div class="text-center profile-details">
                <h4>{{item.title}}</h4>
                <h6>{{item.name}}</h6>
            </div>
            <div class="row" style="padding: 10px;">
                <p *ngIf="item.mobile" style="font-size: 13px;" class="card-text"><i style="margin-right:10px" class="fa fa-mobile"></i> {{item.mobile}}</p>
                <p style="font-size: 13px;" class="card-text"><i style="margin-right:10px" class="fa fa-phone"></i> {{item.officePhone}} Ext: {{item.officeExtension}}</p>
                <p style="font-size: 13px;" class="card-text"><i style="margin-right:10px" class="fa fa-envelope"></i> {{item.email}}</p>
            </div>
        </div>
    </div>
</div>